var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","outlined":"","href":_vm.hubspotTicketUrl,"target":_vm.hubspotTicketUrl ? '_blank' : undefined,"rel":"noopener"}},[_vm._v(" "+_vm._s(_vm.$t('supportRequests.card.ticket', { id: _vm.ticketId }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }